import axios from 'axios'
import { IPublicClientApplication } from '@azure/msal-browser'
import { protectedResources } from '../authConfig'
import { authorizedDelete, authorizedGet, authorizedPost, authorizedPut } from '../utils/authUtils'
import { CommunityGem, CreateUpdateGemRequest, CreateUpdateTagRequest } from '../models/CommunityGem'
import { GemTag } from '../models/GemTag'

const baseUrl = process.env.REACT_APP_BASE_API_URL

// ---- Public endpoints (no auth) ----

export const getPublishedGems = async (tagIds?: number[]): Promise<CommunityGem[]> => {
  const params = tagIds?.length ? tagIds.map(id => `tagIds=${id}`).join('&') : ''
  const url = params ? `${baseUrl}/CommunityGems?${params}` : `${baseUrl}/CommunityGems`
  const response = await axios.get<CommunityGem[]>(url)
  return response.data
}

export const getGemById = async (id: number): Promise<CommunityGem> => {
  const response = await axios.get<CommunityGem>(`${baseUrl}/CommunityGems/${id}`)
  return response.data
}

export const getAllTags = async (): Promise<GemTag[]> => {
  const response = await axios.get<GemTag[]>(`${baseUrl}/GemTags`)
  return response.data
}

// ---- Admin endpoints (require auth) ----

export const adminGetAllGems = async (
  instance: IPublicClientApplication,
): Promise<CommunityGem[]> => {
  return authorizedGet(
    instance,
    `${baseUrl}/Admin/CommunityGems`,
    protectedResources.scopes.read,
  )
}

export const adminCreateGem = async (
  instance: IPublicClientApplication,
  request: CreateUpdateGemRequest,
): Promise<CommunityGem> => {
  return authorizedPost(
    instance,
    `${baseUrl}/Admin/CommunityGems`,
    request,
    protectedResources.scopes.read,
  )
}

export const adminUpdateGem = async (
  instance: IPublicClientApplication,
  id: number,
  request: CreateUpdateGemRequest,
): Promise<CommunityGem> => {
  return authorizedPut(
    instance,
    `${baseUrl}/Admin/CommunityGems/${id}`,
    request,
    protectedResources.scopes.read,
  )
}

export const adminDeleteGem = async (
  instance: IPublicClientApplication,
  id: number,
): Promise<void> => {
  await authorizedDelete<void>(
    instance,
    `${baseUrl}/Admin/CommunityGems/${id}`,
    protectedResources.scopes.read,
  )
}

export const adminCreateTag = async (
  instance: IPublicClientApplication,
  request: CreateUpdateTagRequest,
): Promise<GemTag> => {
  return authorizedPost(
    instance,
    `${baseUrl}/Admin/GemTags`,
    request,
    protectedResources.scopes.read,
  )
}

export const adminUpdateTag = async (
  instance: IPublicClientApplication,
  id: number,
  request: CreateUpdateTagRequest,
): Promise<GemTag> => {
  return authorizedPut(
    instance,
    `${baseUrl}/Admin/GemTags/${id}`,
    request,
    protectedResources.scopes.read,
  )
}

export const adminDeleteTag = async (
  instance: IPublicClientApplication,
  id: number,
): Promise<void> => {
  await authorizedDelete<void>(
    instance,
    `${baseUrl}/Admin/GemTags/${id}`,
    protectedResources.scopes.read,
  )
}
